module.exports = new __parcel__URL__("oh_no_text.49b1176c.png").toString();